import { useSearchParams } from "react-router-dom"
import { Card } from "../components/ui/card"

const GOOGLE_G_ICON_URL =
  "data:image/svg+xml;utf8," +
  encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18">
      <path fill="#4285F4" d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.48h4.844a4.14 4.14 0 0 1-1.796 2.717v2.258h2.908c1.702-1.567 2.684-3.874 2.684-6.615z"/>
      <path fill="#34A853" d="M9 18c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.836.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 0 0 9 18z"/>
      <path fill="#FBBC05" d="M3.964 10.71A5.41 5.41 0 0 1 3.682 9c0-.593.102-1.17.282-1.71V4.958H.957A8.996 8.996 0 0 0 0 9c0 1.452.348 2.827.957 4.042l3.007-2.332z"/>
      <path fill="#EA4335" d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 0 0 .957 4.958L3.964 7.29C4.672 5.163 6.656 3.58 9 3.58z"/>
    </svg>`,
  )

/** open redirect 防止: 相対 path (/ 始まり、// 始まらない、scheme/host なし) のみ許可 */
function safeNext(raw: string | null): string | null {
  if (!raw) return null
  // raw 段階で wire-level シーケンスを拒否 (URL parser の正規化で `\` → `/`、
  // `/\evil.com` → `//evil.com` 化するブラウザがあるため)
  if (raw.includes("\\")) return null
  if (!raw.startsWith("/")) return null
  if (raw.startsWith("//")) return null
  try {
    const parsed = new URL(raw, window.location.origin)
    if (parsed.origin !== window.location.origin) return null
    // parser 経由の最終 path も `//` 始まりではないことを確認 (defense in depth)
    const finalPath = parsed.pathname + parsed.search + parsed.hash
    if (finalPath.startsWith("//")) return null
    return finalPath
  } catch {
    return null
  }
}

export function Login() {
  const [search] = useSearchParams()
  // Stage C で backend が next 対応するまでは frontend → backend に query を渡しても
  // backend が無視するので、PR2 段階では url 上に残るだけ。validation だけ先回り。
  const nextPath = safeNext(search.get("next"))

  const handleSignIn = () => {
    // backend /auth/login が code_verifier + state を Cookie に発行し、Supabase に redirect
    // 認証完了後は backend /auth/callback で omc_session cookie を発行し / に redirect
    const qs = nextPath ? `?next=${encodeURIComponent(nextPath)}` : ""
    window.location.assign(`/auth/login${qs}`)
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-canvas px-8">
      <Card className="flex w-full max-w-md flex-col items-center gap-7 p-12">
        <div className="flex items-center gap-2.5">
          <span className="size-2.5 rounded-full bg-accent" />
          <h1 className="text-lg font-semibold text-text-primary">OMC</h1>
        </div>

        <div className="flex flex-col items-center gap-2.5">
          <h2 className="text-2xl font-semibold text-text-primary">ショート切り抜き候補を抽出</h2>
          <p className="text-[13px] text-text-secondary">
            配信 URL から「ここが盛り上がる」を自動で候補化します
          </p>
        </div>

        <button
          type="button"
          onClick={handleSignIn}
          className="inline-flex items-center gap-3 rounded-lg bg-white px-6 py-3 text-sm font-medium text-[#1f1f1f] shadow-sm transition-colors hover:bg-gray-50"
        >
          {/* 装飾アイコン: 隣接テキスト「Google でログイン」と冗長になるので screen reader から hide */}
          <img src={GOOGLE_G_ICON_URL} alt="" aria-hidden="true" className="size-[18px]" />
          Google でログイン
        </button>

        <div className="flex flex-col items-center gap-1 text-center">
          <p className="text-xs text-text-muted">初回ログイン時にアカウントが自動で作成されます</p>
          <p className="text-xs text-text-muted">
            Google アカウントの email / 表示名のみ取得します
          </p>
        </div>
      </Card>
    </div>
  )
}
